import { TypographyP2 } from '@heidi/design-system/typography';
import { ClinicalTaskCategoryChip } from '@heidi/tasks';
import { cn } from '@heidi/utils';
import { Circle } from 'lucide-react';

import type { JSX } from 'react';

export interface ClinicalTaskRowProps {
  title: string;
  /** Task category key (``order`` / ``coordinate`` / …); ``null`` hides the chip. */
  category?: string | null;
  className?: string;
}

/**
 * Read-only clinical-task row used by the Projects `ClinicalTaskToolBlock`
 * preview: a single tidy line of leading marker, title, and trailing category
 * chip.
 */
export const ClinicalTaskRow = ({
  title,
  category,
  className,
}: ClinicalTaskRowProps): JSX.Element => {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-lg border border-border bg-surface px-2.5 py-2',
        className
      )}
    >
      <Circle className="mt-1 size-3.5 shrink-0 text-text-tertiary" aria-hidden="true" />

      <TypographyP2
        className="min-w-0 flex-1 whitespace-normal break-words font-medium text-text-primary"
        title={title}
      >
        {title}
      </TypographyP2>

      <ClinicalTaskCategoryChip category={category} className="-my-0.5 shrink-0" />
    </div>
  );
};
